/**
 * Notification components for the SCAD system
 * Reusable styled components for notifications across the application
 */

import styled, { css, keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const NotificationBar = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 18px 30px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1100;
  animation: ${slideIn} 0.3s ease-out forwards;
  display: flex;
  align-items: center;
  max-width: 400px;
  
  ${props => {
    switch(props.type) {
      case 'success':
        return css`
          background-color: #4CAF50;
          color: white;
        `;
      case 'error':
        return css`
          background-color: #F44336;
          color: white;
        `;
      case 'warning':
        return css`
          background-color: #FFC107;
          color: #263238;
        `;
      case 'info':
      default:
        return css`
          background-color: #2196F3;
          color: white;
        `;
    }
  }}
`;

export const NotificationIcon = styled.div`
  margin-right: 12px;
  font-size: 20px;
`;

export const NotificationContent = styled.div`
  flex: 1;
`;

export const NotificationTitle = styled.div`
  font-weight: bold;
  margin-bottom: 4px;
`;

export const NotificationMessage = styled.div`
  margin: 10px;
  padding: 0 5px;
  font-size: 14px;
  line-height: 1.5;
`;

export const NotificationCloseButton = styled.button`
  background: none;
  border: none;
  color: inherit;
  opacity: 0.7;
  cursor: pointer;
  margin-left: 12px;
  font-size: 18px;
  transition: all 0.25s ease;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  
  &:hover {
    opacity: 1;
    background: rgba(255, 255, 255, 0.1);
    transform: scale(1.1);
  }
  
  &:focus {
    outline: none;
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const NotificationComponents = {
  NotificationBar,
  NotificationIcon,
  NotificationContent,
  NotificationTitle,
  NotificationMessage,
  NotificationCloseButton
};

export default NotificationComponents;
